module.exports = __webpack_public_path__ + "static/media/IBB1.199f6fd1.mp4";